import baustein from "baustein";
import CountryOverlay from "web/script/components/overlays/country-overlay";
import globalEvents from "web/script/utils/global-events";
import store from "web/redux/store";
import { openSignupOverlay } from "web/redux/ducks/signup-overlay";

const name = "app-pre-header-bar-classic";
const JOIN_SELECTOR = `.${name}__signup`;
const LOGIN_SELECTOR = `.${name}__login`;
const COUNTRY_PICKER_SELECTOR = `.${name}__country-picker`;

const CART_SELECTOR = `.${name}__burger-inner__glyphs-container__burger-cart`;
const CART_HIDDEN_MODIFIER = `${name}__burger-inner__glyphs-container__burger-cart--hidden`;

export default baustein.register(name, {
    defaultOptions: {
        enableCountryPicker: false,
        cartItemCount: 0,
    },

    init() {
        this._onCartChange = this._onCartChange.bind(this);
    },

    setupEvents(add) {
        add("click", JOIN_SELECTOR, this._onSignUpPrompt);
        add("click", LOGIN_SELECTOR, this._onLoginPrompt);

        if (this.options.enableCountryPicker) {
            add("click", COUNTRY_PICKER_SELECTOR, this._onCountryPickerClick);
        }
    },

    onInsert() {
        globalEvents.on("cart.change", this._onCartChange);
    },

    /**
     * When the component is removed we can release all global handlers that may have been set.
     */
    onRemove() {
        this.releaseAllGlobalHandlers();
    },

    /**
     * Handler for click events on the country picker menu.
     *
     * @param {Event} event
     */
    _onCountryPickerClick(event) {
        event.stopPropagation();
        event.preventDefault();

        const countryOverlay = new CountryOverlay();
        countryOverlay.appendTo(document.body);
        countryOverlay.open();
    },

    /**
     * Handler for click events on the "sign up" header link.
     */
    _onSignUpPrompt(event) {
        event.preventDefault();

        // send it up to the lyst-app to open
        const signupOverlayOptions = {
            path: "/account/register/",
            queryParams: {
                next: [window.location.pathname + window.location.search],
                product_id: [],
                type: ["signup"],
            },
            formType: "signup",
            pageType: "header",
            pageSubType: "signup_or_login",
        };
        store.dispatch(openSignupOverlay(signupOverlayOptions));
    },

    /**
     * Handler for click events on the "sign in" header link.
     */
    _onLoginPrompt(event) {
        event.preventDefault();

        // send it up to the lyst-app to open
        const signinOverlayOptions = {
            path: "/account/login/",
            queryParams: {
                next: [window.location.pathname + window.location.search],
                product_id: [],
                type: ["sign_in"],
            },
            formType: "sign_in",
            pageType: "header",
            pageSubType: "signup_or_login",
        };
        store.dispatch(openSignupOverlay(signinOverlayOptions));
    },

    _onCartChange(event, data) {
        this.options.cartItemCount = this.options.cartItemCount + data.itemCountDifference;
        let cartSelector = this.el.querySelector(CART_SELECTOR);

        if (
            cartSelector &&
            this.options.cartItemCount > 0 &&
            cartSelector.classList.contains(CART_HIDDEN_MODIFIER)
        ) {
            cartSelector.classList.remove(CART_HIDDEN_MODIFIER);
        }
    },
});
